module.exports = __webpack_public_path__ + "static/media/cte.32d48a87.png";